/**
 * PoppinPay API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
* The DeliveryAddressDeleteResultModel model module.
* @module model/DeliveryAddressDeleteResultModel
* @version 1.0.0
*/
export default class DeliveryAddressDeleteResultModel {
    /**
    * Constructs a new <code>DeliveryAddressDeleteResultModel</code>.
    * @alias module:model/DeliveryAddressDeleteResultModel
    * @class
    */

    constructor() {
        
        
        
    }

    /**
    * Constructs a <code>DeliveryAddressDeleteResultModel</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/DeliveryAddressDeleteResultModel} obj Optional instance to populate.
    * @return {module:model/DeliveryAddressDeleteResultModel} The populated <code>DeliveryAddressDeleteResultModel</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new DeliveryAddressDeleteResultModel();
                        
            
        }
        return obj;
    }





}
